<template>
  <div class="page-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="title">列表信息</div>
        <div class="item">
          <div class="label">支付方式</div>
          <el-select v-model="form.mode" class="input" placeholder="请选择">
            <el-option
              :value="item.value"
              :label="item.name"
              v-for="item in modeList"
              :key="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="item">
          <div class="label">商家ID</div>
          <el-input
            class="input"
            v-model.number="form.sid"
            placeholder="点击输入信息"
          ></el-input>
        </div>
        <div class="item">
          <div class="label">商户全称</div>
          <el-input
            class="input"
            v-model="form.name"
            placeholder="点击输入信息"
          ></el-input>
        </div>
        <div class="item">
          <div class="label">商户号</div>
          <el-input
            class="input"
            v-model="form.mid"
            placeholder="点击输入信息"
          ></el-input>
        </div>
        <div class="item">
          <div class="label">APPID</div>
          <el-input
            class="input"
            v-model="form.appid"
            placeholder="点击输入信息"
          ></el-input>
        </div>
        <div class="item">
          <div class="label">商户证书序列号</div>
          <el-input
            class="input"
            v-model="form.certSerialNum"
            placeholder="点击输入信息"
          ></el-input>
        </div>
        <div class="item">
          <div class="label">商户APIv3密钥</div>
          <el-input
            class="input"
            v-model="form.key"
            placeholder="点击输入信息"
          ></el-input>
        </div>
        <div class="item">
          <div class="label">服务商商户全称</div>
          <el-input
            class="input"
            v-model="form.spName"
            placeholder="点击输入信息"
          ></el-input>
        </div>
        <div class="item">
          <div class="label">服务商商户号</div>
          <el-input
            class="input"
            v-model="form.spMid"
            placeholder="点击输入信息"
          ></el-input>
        </div>
        <div class="item">
          <div class="label">商户私钥</div>
          <div class="input file" v-if="form.keyFileName">
            <div class="file-name">
              {{ form.keyFileName || "" }}
            </div>
            <div class="btn-box">
              <!-- <div class="btn">查看</div> -->
              <div class="btn" @click="deleteFile('keyFileName')">删除</div>
            </div>
          </div>
          <div class="input upload" v-else>
            添加附件
            <input
              type="file"
              class="upload-input"
              ref="input"
              @change="
                (e) => {
                  handleUpload(e, 'keyFileName');
                }
              "
            />
          </div>
        </div>
        <!-- <div class="item">
          <div class="label">商户证书</div>
          <div class="input file" v-if="form.certName">
            <div class="file-name">
              {{ form.certName || "" }}
            </div>
            <div class="btn-box">

              <div class="btn" @click="deleteFile('certName')">删除</div>
            </div>
          </div>
          <div class="input upload" v-else>
            添加附件
            <input
              type="file"
              class="upload-input"
              ref="input"
              @change="
                (e) => {
                  handleUpload(e, 'certName');
                }
              "
            />
          </div>
        </div> -->
        <div class="item">
          <div class="label">服务费费率</div>
          <el-input
            class="input"
            v-model="form.serviceRate"
            placeholder="点击输入信息"
          ></el-input>
        </div>
        <div class="item">
          <div class="label">接收服务费商户全称</div>
          <el-input
            class="input"
            v-model="form.ServiceName"
            placeholder="点击输入信息"
          ></el-input>
        </div>
        <div class="item">
          <div class="label">接收服务费商户号</div>
          <el-input
            class="input"
            v-model="form.ServiceMid"
            placeholder="点击输入信息"
          ></el-input>
        </div>
        <div class="item">
          <div class="label">结算周期</div>
          <el-input
            class="input"
            v-model="form.interval"
            placeholder="点击输入信息"
          ></el-input>
        </div>
        <div class="item">
          <div class="label">备注1</div>
          <el-input
            class="input"
            v-model="form.baseRate"
            placeholder="点击输入信息"
          ></el-input>
        </div>
        <div class="item">
          <div class="label">备注2</div>
          <el-input
            class="input"
            v-model="form.chargeRate"
            placeholder="点击输入信息"
          ></el-input>
        </div>
        <div class="item">
          <div class="label">备注3</div>
          <!-- <el-input
            class="input"
            v-model="form.baseTime"
            placeholder="点击输入信息"
          ></el-input> -->
          <el-date-picker
            class="input"
            v-model="form.baseTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </div>
        <div class="item">
          <div class="label">短信验证码</div>
          <el-input
            class="input"
            v-model="smsCode"
            placeholder="点击输入短信验证码"
          ></el-input>
          <div class="btn" @click="sendSms">获取短信验证码</div>
        </div>
      </div>
      <div class="btn-box">
        <button class="confirm-btn" @click="handleConfirm">保存</button>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
export default {
  components: {
    Header
  },
  name: 'balanceExamine',
  data() {
    return {
      title: {
        // 页面标题
        firstTitile: '收款商户',
        secondTitle: '收款商户'
      },
      loading: 0,
      form: {
        sid: null,
        mode: '',
        name: '',
        mid: '',
        certSerialNum: '',
        key: '',
        keyName: '',
        certName: '',
        spiltName: '',
        appid: '',
        spName: '',
        spMid: '',
        keyFileName: '',
        serviceRate: null,
        ServiceName: '',
        ServiceMid: '',
        interval: null,
        baseRate: null,
        chargeRate: null,
        baseTime: ''
      },
      smsCode: '',
      fileName: '',
      modeList: [
        {
          name: '微信小程序支付',
          value: 'wxPayMini'
        }
      ]
    };
  },

  mounted() {},
  computed: {},
  methods: {
    handleUpload(e, name) {
      let file = e.target.files[0];
      this.loading++;
      this.httpUploadFile(
        this.$root.uploadPay,
        {
          file: file
        },
        { 'Content-Type': 'multipart/form-data' }
      ).then(
        (res) => {
          this.loading--;
          this.$refs.input.value = '';
          this.$message.success('上传成功');
          this.form[name] = res.name;
        },
        (res) => {
          this.loading--;
          this.$refs.input.value = '';
          this.$message.error(res);
        }
      );
    },
    handleConfirm() {
      this.loading++;
      this.form.serviceRate = +this.form.serviceRate;
      this.form.interval = +this.form.interval;
      this.form.baseRate = +this.form.baseRate;
      this.form.chargeRate = +this.form.chargeRate;
      this.httpPost(this.$root.createPay, {
        merchantInfo: this.form,
        smsCode: this.smsCode
      }).then(
        (res) => {
          this.loading--;
          this.$router.push({
            name: 'payRecord'
          });
          this.$message.success('操作成功');
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },

    sendSms() {
      this.httpPost(this.$root.sendSms, {
        type: 11,
        phone: '15263815818'
      }).then(
        (res) => {
          this.loading--;
          this.$message.success('操作成功');
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    deleteFile(name) {
      this.form[name] = '';
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.page-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 10px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 30px 24px;
      border-radius: 2px;

      .title {
        word(20px, #333);
        margin-bottom: 15px;
      }

      .item {
        flex-x(flex-start);
        word(14px, #666);
        height: 50px;

        &.item2 {
          height: auto;
          padding: 10px 0;
        }

        .label {
          width: 180px;
          line-height: 50px;
          align-self: flex-start;
          text-align: right;
        }

        .btn {
          width: 110px;
          height: 32px;
          border-radius: 3px;
          background: #4876FF;
          word(14px, #FFF);
          flex-x(center);
          margin-left: 15px;
        }

        .upload {
          line-height: 50px;
          color: btn-color;
          cursor: pointer;
          position: relative;
          cursor: pointer;

          .upload-input {
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            opacity: 0;
            cursor: pointer;
          }
        }

        .input {
          margin-left: 36px;
          width: 270px;
        }

        .tip {
          color: btn-color;
          margin-left: 15px;
        }

        .file {
          width: auto;
          min-width: 270px;
          flex-x();

          .file-name {
          }

          .btn-box {
            flex-x(flex-start);
            padding-bottom: 0;
            width: auto;

            .btn {
              margin: 0 10px;
              word(14px, #fff);
              cursor: pointer;
              cursor: pointer;
            }
          }
        }

        .zhutu {
          width: 32px;
          height: 32px;
          border-radius: 4px;
        }

        .img {
          width: 112px;
          height: 112px;
          border-radius: 4px;
          margin-right: 15px;
          object-fit: cover;
        }

        .video {
          height: 450px;
        }
      }
    }
  }

  .btn-box {
    background: white;
    width: 100%;
    flex-x(center);
    padding-bottom: 48px;

    .cancel-btn {
      width: 96px;
      height: 40px;
      cancel-btn();
      // border-radius: 23px;
    }

    .confirm-btn {
      width: 96px;
      height: 40px;
      margin-left: 20px;
      confirm-btn();
    }
  }
}
</style>
